/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';
import UiValidate from 'wdna-components/lib/forms/validation/UiValidate';
import countries from 'wdna-components/lib/constants/countries';
import { LovItem } from 'wdna-components/lib/types';

interface Props {
  loading?: boolean;
  areaList?: any[];
  user?: {
    name?: string;
    email?: string;
    area_id?: number;
  };
  info?: {
    dni?: string;
    day?: number;
    month?: number;
    year?: number;
    telephone?: string;
    telephoneAlt?: string;
    country?: string;
    province?: string;
    city?: string;
    address?: string;
    cp?: string;
  };
  submit: (e: React.FormEvent<HTMLFormElement>) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleSelect2: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default class UserInfo extends React.Component<Props> {
  private mounted: boolean;

  public static defaultProps: Partial<Props> = {
    loading: false,
    areaList: [],
    user: {
      name: '',
      email: '',
    },
    info: {
      dni: '',
      day: 0,
      month: 0,
      year: 0,
      telephone: '',
      telephoneAlt: '',
      country: '',
      province: '',
      city: '',
      address: '',
      cp: '',
    }
  };

  public constructor(props: Props) {
    super(props);

    this.mounted = false;

    this.state = {
    };
  }

  public componentDidMount = (): void => {
    this.mounted = true;
  };

  public componentWillUnmount = (): void => {
    this.mounted = false;
  };

  public render(): JSX.Element {
    return (
      <UiValidate>
        <form className="smart-form" onSubmit={this.props.submit}>
          <fieldset>
            <label className="label">User account</label>

            <section>
              <label className="input">
                <i className="icon-append fa fa-envelope" />
                <input
                  type="email"
                  value={this.props.user?.email || ''}
                  onChange={this.props.handleChange}
                  name="email"
                  placeholder="Email"
                />
                <b className="tooltip tooltip-bottom-right">Necesario para verificar tu cuenta</b>{' '}
              </label>
            </section>

            <section>
              <label className="label">User Area</label>
              {this.props.areaList && (
                <Select2
                  name="area_id"
                  data={this.props.areaList.map((area: any): DataSelect2 => {
                    return { text: area.name, id: area.id };
                  })}
                  value={this.props.user?.area_id || ''}
                  options={{
                    placeholder: 'Select user area',
                  }}
                  onChange={this.props.handleSelect2}
                  style={{ width: '100%' }}
                />
              )}
            </section>
          </fieldset>
          <fieldset>
            <label className="label">User data</label>
            <div className="row">
              <section className="col col-6">
                <label className="input">
                  <i className="icon-prepend fa fa-user" />
                  <input
                    type="text"
                    name="name"
                    placeholder="Full name"
                    value={this.props.user?.name || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
              <section className="col col-6">
                <label className="input">
                  <i className="icon-prepend fa fa-user" />
                  <input
                    type="text"
                    name="dni"
                    placeholder="DNI/NIF"
                    value={this.props.info?.dni || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
            </div>
          </fieldset>

          <fieldset>
            <label className="label">Birthday</label>
            <div className="row">
              <section className="col col-3">
                <label className="select">
                  <select name="day" value={this.props.info?.day || '0'} onChange={this.props.handleChange}>
                    <option value="0" disabled>
                      Day
                    </option>
                    {Array.apply(1, Array(31)).map((x: any, i: number): JSX.Element => {
                      return (
                        <option key={i + 1} value={`${i + 1}`}>
                          {i + 1}
                        </option>
                      );
                    })}
                  </select>
                  <i />
                </label>
              </section>

              <section className="col col-3">
                <label className="select">
                  <select name="month" value={this.props.info?.month || '0'} onChange={this.props.handleChange}>
                    <option value="0" disabled>
                      Month
                    </option>
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                  <i />
                </label>
              </section>
              <section className="col col-3">
                <label className="select">
                  <select name="year" value={this.props.info?.year || '0'} onChange={this.props.handleChange}>
                    <option value="0" disabled>
                      Year
                    </option>
                    {Array.apply(1, Array(118)).map((x: any, i: number): JSX.Element => {
                      return (
                        <option key={i + 1900} value={i + 1900}>
                          {i + 1900}
                        </option>
                      );
                    })}
                  </select>
                  <i />
                </label>
              </section>
            </div>
          </fieldset>

          <fieldset>
            <label className="label">Contact</label>
            <div className="row">
              <section className="col col-6">
                <label className="input">
                  <i className="icon-prepend fa fa-phone" />
                  <input
                    type="tel"
                    name="telephone"
                    placeholder="Phone"
                    value={this.props.info?.telephone || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
              <section className="col col-6">
                <label className="input">
                  <i className="icon-prepend fa fa-phone" />
                  <input
                    type="tel"
                    name="telephoneAlt"
                    placeholder="Alt phone"
                    value={this.props.info?.telephoneAlt || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
            </div>
          </fieldset>

          <fieldset>
            <label className="label">Address</label>
            <div className="row">
              <section className="col col-4">
                <label className="select">
                  <select name="country" value={this.props.info?.country || ' '} onChange={this.props.handleChange}>
                    <option value=" " disabled>
                      Country
                    </option>
                    {countries.map((country: LovItem) => {
                      return (
                        <option key={String(country.key) + country.value} value={country.value}>
                          {country.value}
                        </option>
                      );
                    })}
                  </select>

                  <i />
                </label>
              </section>

              <section className="col col-4">
                <label className="input">
                  <input
                    type="text"
                    name="province"
                    placeholder="Province"
                    value={this.props.info?.province || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>

              <section className="col col-4">
                <label className="input">
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={this.props.info?.city || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
            </div>
            <div className="row">
              <section className="col col-9">
                <label htmlFor="address" className="input">
                  <input
                    type="text"
                    name="address"
                    id="address"
                    placeholder="Street"
                    value={this.props.info?.address || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
              <section className="col col-3">
                <label className="input">
                  <input
                    type="text"
                    name="cp"
                    placeholder="Postal Code"
                    value={this.props.info?.cp || ''}
                    onChange={this.props.handleChange}
                  />
                </label>
              </section>
            </div>
          </fieldset>

          <footer>
            <div className="text-right">
              {this.props.loading && <img className="loading-wdna" src="assets/img/loading-wdna.gif" alt="logo" />}
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </footer>
        </form>
      </UiValidate>
    );
  }
}
